// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"fbf235c2","488":"652112cf"}[chunkId] + ".chunk.js";
};